// Short attention chirp + haptic for Engage's delayed welcome reveal.
// Two-tone soft sine ~160ms, peak gain 0.06 (subtle, not alert).
// AudioContext autoplay policy may block — silent failure is OK.

let ctx: AudioContext | null = null;

export function playChirp(): void {
  if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
    try { navigator.vibrate(40); } catch { /* outside user gesture */ }
  }
  if (typeof window === 'undefined') return;
  const Ctor =
    window.AudioContext ??
    (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return;
  try {
    if (!ctx) ctx = new Ctor();
    if (ctx.state === 'suspended') void ctx.resume().catch(() => undefined);
    const t = ctx.currentTime;
    tone(ctx, 660, t, 0.07, 0.06);
    tone(ctx, 880, t + 0.07, 0.09, 0.05);
  } catch {
    /* audio blocked */
  }
}

function tone(c: AudioContext, hz: number, at: number, dur: number, peak: number): void {
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = 'sine';
  osc.frequency.value = hz;
  g.gain.setValueAtTime(0, at);
  g.gain.linearRampToValueAtTime(peak, at + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, at + dur);
  osc.connect(g).connect(c.destination);
  osc.start(at);
  osc.stop(at + dur + 0.02);
}
